import { fabric } from 'fabric';
import { Parts } from './PolicyRect';

const PolicyLabels = fabric.util.createClass(fabric.Group, {
  type: Parts.Labels,

  initialize: function (objects: fabric.Object[], options: fabric.IGroupOptions) {
    this.callSuper('initialize', objects, options);
  },

  toObject: function (propsToInclude?: string[]) {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      ...propsToInclude,
      originX: this.originX,
      originY: this.originY,
    });
  },
});

PolicyLabels.fromObject = function (object: fabric.Object, callback: (obj: fabric.Object) => void) {
  const labels = object as fabric.PolicyLabels;
  const obj = new PolicyLabels(labels.objects, labels);
  if (callback) callback(obj);
  return obj;
};

export default PolicyLabels;
